import { Card, CardBody, CardBodyProps, CardHeader, CardProps, Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface SectionBoxProps extends CardProps {
  bodyProps?: CardBodyProps;
  headerContent?: ReactNode;
}

export const SectionBox = ({ children, bodyProps, headerContent, ...rest }: SectionBoxProps) => (
  <Card {...rest}>
    {headerContent && (
      <>
        <CardHeader>
          <Flex justify='space-between' align='center'>
            {headerContent}
          </Flex>
        </CardHeader>
      </>
    )}
    <CardBody display='flex' flexDirection='column' gap='kilo' align='stretch' {...bodyProps}>
      {children}
    </CardBody>
  </Card>
);
